// File to import every rules
module.exports = {
  ...require('./workoutRules'),
  ...require('./workoutTargetRules'),
  ...require('./forWorkoutRule'),
  ...require('./conditionsRules'),
};
